module.exports = __webpack_public_path__ + "static/media/33.08a22b3e.svg";